import ReactPlayer from 'react-player/lazy';

import type { VideoType } from '@/src/Types/Blocks/Video';

import Decorations from '../../_components/Decorations';
import { getBtnSettingsToCSS } from '../../_lib/btns';
import VideoBig from './variants/Big';
import VideoSmall from './variants/Small';

type VideoProps = Omit<VideoType, 'block_theme'>;

export const Video = (props: VideoProps) => {
	const {
		variant = 'small',
		style,
		ctasStyle,
		context = 'video',
		placement,
		sectionDecoration,
		id,
	} = props;

	const previewUrl = (
		<ReactPlayer width='100%' height='100%' url={props.url} controls={true} volume={0} />
	);

	const videoProps: VideoType = {
		...props,
		context: context,
		previewUrl,
		sectionDecoration: sectionDecoration,
		headingFontClassName: {
			title: 'minos-video-heading-title-font-style tablet:minos-video-heading-title-font-style',
			text: {
				p: 'minos-video-heading-description-font-style tablet:minos-video-heading-description-font-style mb-5 tablet:mb-6 last:mb-0',
				a: getBtnSettingsToCSS(ctasStyle, 'a', context),
				btnPrimary: getBtnSettingsToCSS(ctasStyle, 'primary', context),
				btnSecondary: getBtnSettingsToCSS(ctasStyle, 'secondary', context),
				btnTertiary: getBtnSettingsToCSS(ctasStyle, 'tertiary', context),
			},
		},
	};

	const variations = {
		small: <VideoSmall {...videoProps} />,
		big: <VideoBig {...videoProps} />,
	};

	return (
		<>
			<section id={id} className='relative' data-variant={`video-${variant}`} style={style}>
				<Decorations
					isSectionDecorated={sectionDecoration?.isSectionDecorated}
					type={sectionDecoration?.type}
					pathClassName={`${sectionDecoration?.type === 'wave' ? 'fill-minos-video-bg-color' : 'fill-minos-decoration-bubble-left'}`}
					pathClassNameRightCircle={`${sectionDecoration?.type === 'bubble' && 'fill-minos-decoration-bubble-right'}`}
					placement={placement}
				>
					{variations[variant]}
				</Decorations>
			</section>
		</>
	);
};

export default Video;
